import { useState,useEffect, useMemo } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitleDefault from '../default/DialogTitleDefault';
import { Box, Divider, Grid, TextField, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ButtonBasic, SelectTipoSubMotivoBaja } from '../../components';
import SubMotivoBajaService from '../../services/subMotivoBaja.service';

const ModalSubMotivoBaja = ({show, hideModal, item, onGuardar, type}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [isLoading, setIsLoading] = useState(false);
    const handleClose = () => hideModal();
    const [formAll, setFormAll] = useState({
        nombre_smb: {
            texto: null,
            textoErr: 'El titulo es requerido',
            estadoErr: false,
            tipo: 'string'
        },
        tipoCategoria_smb: {
            texto: null,
            textoErr: 'El segmento es requerido',
            estadoErr: false,
            tipo: 'string'
        }
    });
    const onChangeForm = (value,input) =>{
        let formOld = formAll;
        if(!formOld[input]){
            formOld[input] = {
                texto: value,
                textoErr: `El ${input} es requerido`,
                estadoErr: false,
                tipo: 'string'
            }
        }else{
            formOld[input].texto = value
        }
        if((!value || value === '') && input !== 'telefono_c'){
            formOld[input].estadoErr = true
        }else{
            formOld[input].estadoErr = false;
        }
        setFormAll({...formOld})
    }
    const onChangeFormSetError = (input,clear) =>{
        let formOld = formAll;
        formOld[input].estadoErr = !clear ? true : false
        setFormAll({...formOld})
    }
    const onSubmit = async() => {
        const form = {createdEmp_mt: 'NUBICOM'};
        let isOk = false;
        setIsLoading(true);
        const inputRequired = ['nombre_smb','tipoCategoria_smb']
        const propertyNames = Object.keys(formAll);
        await Promise.resolve(
        propertyNames.forEach((name)=>{
        if(formAll[name]?.texto && formAll[name]?.texto !== '' && !formAll[name]?.estadoErr){
            form[name] = formAll[name].texto
        }else{
            if(inputRequired.includes(name)){
                isOk = true;
                onChangeFormSetError(name)
            }
        }
        }))
        if(!isOk){
            if(item?.id_smb > 0) {
                form.id_smb = item.id_smb
                await SubMotivoBajaService.update(form)
                    .then(() => {
                        onGuardar();
                        hideModal();
                    })
                    .finally(() => {
                        setIsLoading(true);
                    });
            }else{
                await SubMotivoBajaService.register(form)
                    .then(() => {
                        onGuardar();
                        hideModal();
                    })
                    .finally(() => {
                        setIsLoading(true);
                    });
            }
        }else{
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if(item){
            setTimeout(() => {
                onChangeForm(item?.nombre_smb,'nombre_smb')
                onChangeForm(item?.tipoCategoria_smb || 24,'tipoCategoria_smb')
            }, 100);
        }
    }, [item])

    const styleInput = useMemo(() => ({
        '& .MuiInputLabel-root':{
            color: isDarkMode ? '#b0bec5' : 'gray',
            fontSize: 14,
            marginTop: -0.4
        },
        '& fieldset': {
            borderRadius: 2,
            height: 50,
            border: 1,
            borderColor: isDarkMode ? '#3d4a62' : 'gray',
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                border:1,
                color: isDarkMode ? '#e0e0e0' : '#000',
                borderColor: isDarkMode ? '#90caf9' : '#0364ff',
                height: 50,
            },
            '&:hover':{
                border: 0.1,
                borderRadius: 2,
                borderColor: isDarkMode ? '#3d4a62' : 'gray',
                height: 45,
            },
            '&.Mui-focused': {
                '&:hover':{
                    border: 0,
                    borderRadius: 2,
                    height: 45,
                }
            },
            color: isDarkMode ? '#e0e0e0' : 'gray',
            height: 45,
        }
    }), [isDarkMode]);

    return(
        <Dialog open={show} disableEscapeKeyDown maxWidth='sm' fullWidth sx={{backdropFilter: 'blur(0.4px);'}}>
            <Box sx={{background: isDarkMode ? '#2d3a52' : '#fff'}}>
                <DialogTitleDefault id="add-canal-priv" onClose={handleClose}>
                    <Typography sx={{flex:1,textAlign: 'center', color: isDarkMode ? '#e0e0e0' : '#000',fontWeight: 'bold'}} variant='h5'>
                        {item?.id_smb > 0 ? 'Editar Sub-Motivo Baja' : 'Registrar Sub-Motivo Baja'}
                    </Typography>
                </DialogTitleDefault>
                <Divider sx={{borderColor: isDarkMode ? '#3d4a62' : 'gray'}} />
                <DialogContent>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}>Nombre</Typography>
                            <TextField
                                fullWidth
                                autoComplete='off'
                                value={formAll.nombre_smb.texto}
                                error={formAll.nombre_smb.estadoErr}
                                helperText={formAll.nombre_smb.estadoErr && formAll.nombre_smb.textoErr}
                                onChange={(e)=>onChangeForm(e.target.value, 'nombre_smb')}
                                sx={styleInput}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}>Categoria</Typography>
                            <SelectTipoSubMotivoBaja
                                value={formAll.tipoCategoria_smb.texto}
                                onChange={(opt) => onChangeForm(opt.value,'tipoCategoria_smb')}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider sx={{borderColor: isDarkMode ? '#3d4a62' : 'gray'}} />
                <DialogActions sx={{display:'flex', justifyContent:'center'}}>
                    <ButtonBasic
                        textButton='Cancelar'
                        variant='wk'
                        color='cancel'
                        onClick={()=>handleClose()}
                        isLoading={isLoading}
                    />
                    <ButtonBasic
                        textButton='Guardar'
                        onClick={()=>onSubmit()}
                        isLoading={isLoading}
                        variant='wk'
                        color='nextStep'
                    />
                </DialogActions>
            </Box>
        </Dialog>
    )
}

export default ModalSubMotivoBaja